import { formatDateTime } from "@/common/utils/formatters";
import {
  ArrowBigRightIcon,
  BriefcaseBusinessIcon,
  Building2Icon,
} from "lucide-react";
import { Link } from "react-router-dom";
import { NegotiationData } from "../types/negotiations.type";
import { negotiationStatus } from "../constants/negotiationStatus.constant";
import { getDateDiffInDays } from "@/common/utils/date";
import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import Button from "@/common/components/Button";
import ButtonLink from "@/common/components/ButtonLink";

export class NegotiationsTransformer {
  static tableTransformer() {
    return (negotiations: NegotiationData[]) => {
      return negotiations.map((negotiation) => {
        const daysDiff = negotiation.due_at
          ? getDateDiffInDays(new Date(), new Date(negotiation.due_at))
          : null;

        const dueForDisplay = (() => {
          if (!negotiation.due_at || daysDiff === null) return "";

          if (daysDiff <= 0) {
            return (
              <span className="text-danger-soft font-medium">Encerrado</span>
            );
          }

          return `${daysDiff} dias`;
        })();

        return {
          ...negotiation,
          _className:
            negotiation.status === "awaiting_establishment_response" &&
            "bg-yellow-op-2",
          status: negotiation.status
            ? negotiationStatus[negotiation.status]
            : "",
          created_at: negotiation.created_at
            ? formatDateTime(new Date(negotiation.created_at))
            : "",
          accepted_at: negotiation.accepted_at
            ? formatDateTime(new Date(negotiation.accepted_at))
            : "",
          due_for: dueForDisplay,
          client_company: (
            <ButtonLink
              linkTo={`/companies/${negotiation.client_company?.id}`}
              operationKlassToCheckPermission="Admin::Client::Companies::Show"
            >
              <ImageWithDisplayName
                placeholderIcon={BriefcaseBusinessIcon}
                imageUrl={
                  negotiation.client_company?.general_information?.company_logo
                    ?.url
                }
                displayName={
                  negotiation.client_company?.general_information?.fantasy_name
                }
              />
            </ButtonLink>
          ),
          establishment: (
            <ButtonLink
              linkTo={`/establishments/${negotiation.establishment_company?.id}`}
              operationKlassToCheckPermission="Admin::Establishment::Companies::Show"
            >
              <ImageWithDisplayName
                placeholderIcon={Building2Icon}
                imageUrl={
                  negotiation.establishment_company?.general_information
                    ?.company_logo?.url
                }
                displayName={
                  negotiation.establishment_company?.general_information
                    ?.fantasy_name
                }
              />
            </ButtonLink>
          ),
          actions: (
            <Link to={`/negotiations/${negotiation.id}`}>
              <Button
                variant="link-white"
                operationKlassToCheckPermission="Admin::Client::Negotiations::Show"
              >
                <ArrowBigRightIcon />
              </Button>
            </Link>
          ),
        };
      });
    };
  }
}
